export default [
  {
    linkName: 'Home',
    linkID: 1,
    linkRoute: '/',
  },
  {
    linkName: 'Archives',
    linkID: 2,
    linkRoute: '/archives',
  },
  // {
  //   linkName: 'Categories',
  //   linkID: 3,
  //   linkRoute: '/categories',
  // },
  {
    linkName: 'About',
    linkID: 4,
    linkRoute: '/about',
  },
]



// WEBPACK FOOTER //
// ./src/client/components/navMenu/links.js